import { staffRequestAction } from "../../../_store";

export const handleReviewRequestFormNavigation = (
  direction = "next",
  list,
  indexValue,
  history,
  source,
  dispatch
) => {
  var formType = 0;
  var row = {};

  if (list?.DataList?.length === indexValue) {
    //if in last last need to move first list (from nth to 0)
    formType = list?.DataList[0]?.RequestFormType;
    row = list?.DataList[0];
    dispatch(staffRequestAction?.updateIndexValue(0));
  } else {
    let updateIndex = indexValue <= 0 ? 0 : indexValue;
    formType = list?.DataList[updateIndex]?.RequestFormType;
    row = list?.DataList[updateIndex];
    dispatch(staffRequestAction?.updateIndexValue(updateIndex));
  }
  switch (formType) {
    case 1:
      history.navigate("StaffRequestList/VisitorRequestForm", {
        state: {
          formID: row?.RequestFormTypeID,
          formDetails: list,
          sourceFrom: source,
          RequestFormType: row.RequestFormType,
        },
      });
      break;

    case 60:
      history.navigate("StaffRequestList/LegalResearchRequest", {
        state: {
          formID: row?.RequestFormTypeID,
          formDetails: list,
          sourceFrom: source,
          RequestFormType: row.RequestFormType,
        },
      });
      break;

    case 2:
      history.navigate("StaffRequestList/RequestRemedyForm", {
        state: {
          formID: row?.RequestFormTypeID,
          formDetails: list,
          sourceFrom: source,
          RequestFormType: row.RequestFormType,
        },
      });
      break;
    case 53:
      history.navigate("StaffRequestList/PublicDefenderForm", {
        state: {
          formID: row?.RequestFormTypeID,
          formDetails: list,
        },
      });
      break;

    case 62:
      history.navigate("StaffRequestList/PublicDefenderFormCrisp", {
        state: {
          formID: row?.RequestFormTypeID,
          formDetails: list,
        },
      });
      break;

    case 63:
      history.navigate("StaffRequestList/PublicDefenderServiceForm", {
        state: {
          formID: row?.RequestFormTypeID,
          formDetails: list,
        },
      });
      break;

    case 59:
      history.navigate("StaffRequestList/PublicDefenderFormCrisp", {
        state: {
          formID: row?.RequestFormTypeID,
          formDetails: list,
        },
      });
      break;

    default:
      break;
  }
  if (
    formType >= 3 &&
    formType !== 53 &&
    formType !== 59 &&
    formType !== 63 &&
    formType !== 60 &&
    formType !== 62
  ) {
    history.navigate("StaffRequestList/RequestFormInfo", {
      state: {
        formID: row?.RequestFormTypeID,
        RequestFormType: row?.RequestFormType,
        oldRequestFormTitle: row?.RequestFormTitle,
        InmateID: row?.InmateID,
        InmateResidentId: row?.InmateResidentId,
        formDetails: list,
      },
    });
  }
};
